import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=21dc3ee4&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=js&"
export * from "./GroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=21dc3ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc3ee4",
  null
  
)

export default component.exports